import React, { useState } from "react";
import "./ContactForm.css";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";

export default function ContactForm() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const phoneRegex = /^\d{7,15}$/;

  const handleChange = (e) => {
    let { name, value } = e.target;

    if (name === "phone") {
      value = value.replace(/[^0-9]/g, "").slice(0, 15);
    }

    setFormData({ ...formData, [name]: value });
  };

  const validate = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = "Please enter your name.";
    } else if (formData.name.trim().length < 3) {
      newErrors.name = "Name must be at least 3 characters.";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Please enter your email.";
    } else if (!emailRegex.test(formData.email.trim())) {
      newErrors.email = "Enter a valid email.";
    }

    if (!formData.phone.trim()) {
      newErrors.phone = "Please enter phone number.";
    } else if (!phoneRegex.test(formData.phone.trim())) {
      newErrors.phone = "Enter valid 7–15 digit contact number.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setLoading(true);

    try {
      const response = await fetch(
        "https://test5.cfcsitservices.co.in/Enquiry",
        {
          method: "POST",
          headers: {
            Accept: "*/*",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            name: formData.name.trim(),
            email: formData.email.trim(),
            phone: formData.phone.trim(),
          }),
        }
      );

      const data = await response.json();

      if (response.ok) {
        window.location.href = "/thankyou";
      } else {
        alert(data?.message || "Submission failed");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Network error, try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="formBx">
      <form className="muiForm" onSubmit={handleSubmit}>
        <h2>Contact Us</h2>

        <TextField
          fullWidth
          label="Your Name"
          name="name"
          variant="outlined"
          value={formData.name}
          onChange={handleChange}
          error={!!errors.name}
          helperText={errors.name}
          disabled={loading}
        />

        <TextField
          fullWidth
          label="Email"
          name="email"
          variant="outlined"
          value={formData.email}
          onChange={handleChange}
          error={!!errors.email}
          helperText={errors.email}
          disabled={loading}
        />

        <TextField
          fullWidth
          label="Phone Number"
          name="phone"
          variant="outlined"
          value={formData.phone}
          onChange={handleChange}
          inputProps={{ maxLength: 15 }}
          error={!!errors.phone}
          helperText={errors.phone}
          disabled={loading}
        />

        <Button
          type="submit"
          variant="contained"
          className="muiBtn"
          disabled={loading}
        >
          {loading ? (
            <CircularProgress size={22} color="inherit" />
          ) : (
            "SUBMIT"
          )}
        </Button>
      </form>
    </div>
  );
}
